import React, { createContext, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const EnvironmentContext = createContext();

const EnvironmentProvider = ({ children }) => {
    const [playMusicBool, setPlayMusicBool] = useState(true)
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isItAnAdvancedUser, setIsItAnAdvancedUser] = useState(false);
    const [userTokenCount, setUserTokenCount] = useState(0);
    const [modelChosen, setModelChosen] = useState('mistral-small');
    const [apiKey, setApiKey] = useState('');
    const [user, setUser] = useState(null);
    const [alreadyStartedStories, setAlreadyStartedStories] = useState(false);
    const [uuidOfCurrentStory, setUuidOfCurrentStory] = useState('l4dVqXlfWapXnOzBNiJr')
    const [showBuyModal, setShowBuyModal] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const location = useLocation();
    const createMode = location.pathname.startsWith('/Create');
    const [flyMode, setFlyMode] = useState(false);
    const audioRef = useRef(null);
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    // Gacha UX states
    const [showDailyRewardModal, setShowDailyRewardModal] = useState(false);
    const [dailyRewardData, setDailyRewardData] = useState(null);
    const [showLowCreditsModal, setShowLowCreditsModal] = useState(false);
    const [lowCreditsNeeded, setLowCreditsNeeded] = useState(10);
    const [creditNotification, setCreditNotification] = useState({ show: false, credits: 0, type: 'daily' });

    const value = {
        isMobile,
        playMusicBool, setPlayMusicBool,
        showBuyModal, setShowBuyModal,
        notifications, setNotifications,
        audioRef,
        isFullScreen, setIsFullScreen,
        isItAnAdvancedUser, setIsItAnAdvancedUser,
        userTokenCount, setUserTokenCount,
        modelChosen, setModelChosen,
        apiKey, setApiKey,
        user, setUser,
        alreadyStartedStories, setAlreadyStartedStories,
        uuidOfCurrentStory, setUuidOfCurrentStory,
        createMode,
        flyMode: flyMode, setFlyMode: setFlyMode,
        // Gacha UX
        showDailyRewardModal, setShowDailyRewardModal,
        dailyRewardData, setDailyRewardData,
        showLowCreditsModal, setShowLowCreditsModal,
        lowCreditsNeeded, setLowCreditsNeeded,
        creditNotification, setCreditNotification,
    }

    return (
        <EnvironmentContext.Provider value={value}>
            {children}
        </EnvironmentContext.Provider>
    );
}

export { EnvironmentProvider, EnvironmentContext };